import { render, staticRenderFns } from "./groupLabelManagerment.vue?vue&type=template&id=311ed7de&scoped=true&"
import script from "./groupLabelManagerment.vue?vue&type=script&lang=js&"
export * from "./groupLabelManagerment.vue?vue&type=script&lang=js&"
import style0 from "./groupLabelManagerment.vue?vue&type=style&index=0&id=311ed7de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311ed7de",
  null
  
)

export default component.exports